export default __webpack_public_path__ + "static/media/helicopter.e5e11190.svg";